//type: enum
//description: États internes pour bnum-segmented-item

/**
 * États possibles pour l'élément bnum-segmented-item.
 */
export enum States {
  SELECTED = 'selected',
  DISABLED = 'disabled',
  ICON = 'icon',
}
